import axios from 'axios';

// Client public dédié : pas de cookie, pas d'intercepteur. api.service.js
// redirige vers /403 au premier refus, ce qui casserait cet écran anonyme.
const clientPublic = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://127.0.0.1:5003',
  withCredentials: false,
});

export const demanderReinitialisation = async (login, country) => {
  const response = await clientPublic.post('/mot-de-passe-oublie', { login, country });
  return response.data;
};

export const verifierJetonReinitialisation = async (jeton, country) => {
  const response = await clientPublic.post('/reinitialisation/verifier', { jeton, country });
  return response.data;
};

export const definirNouveauMotDePasse = async (jeton, motDePasse, country) => {
  const response = await clientPublic.post('/reinitialisation/mot-de-passe', {
    jeton,
    mot_de_passe: motDePasse,
    country,
  });
  return response.data;
};

// Invitation d'un utilisateur ajouté depuis le portail (Yros/payor_enterprise#319) :
// même relais que la réinitialisation, vers les routes d'invitation du proxy.
export const verifierJetonInvitation = async (jeton, country) => {
  const response = await clientPublic.post('/invitation/verifier', { jeton, country });
  return response.data;
};

export const accepterInvitation = async (jeton, motDePasse, country) => {
  const response = await clientPublic.post('/invitation/mot-de-passe', {
    jeton,
    mot_de_passe: motDePasse,
    country,
  });
  return response.data;
};
